import StressButton from "../../../components/StressButton";

const StressFull = ({numStress}) => {
    return <div className={`flex ${numStress === 3 && "flex-col md:"}flex-row`}>
        {[...Array(numStress)].map((_, i) => <>
            {i !== 0 && <div className='flex h-16 items-center justify-center'>
                <p className='text-center font-bold text-xl px-3'>or</p>
            </div>}
            <StressButton numStress={numStress} mainStress={i} />
        </>)}
    </div>
}

export default StressFull;